/* eslint-disable import/prefer-default-export */

export function toggleDarkMode() {
    return { type: 'TOGGLE_DARK_MODE' };
}
